import React,{ createRef } from 'react';
import { Buffer } from 'buffer';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { formatCurrency } from '../utils/FormatCurrency';
import { parseISO, format } from 'date-fns';

export const InfoBody = (props) => {
  
  return(
    <Button
    className='p-button-rounded infoButton'
    icon='pi pi-exclamation-circle'
    tooltip='Ver mais detalhes'
    onClick={(e)=>{props.handleClick(e)}}
    >
    </Button>
    )
  }

export const colunaBoletoBody = (rowData) => {
    const menu = createRef();
  
    const listaBoletos = rowData.map((boletos)=>({
    label:`Boleto de ${formatCurrency(boletos.boleto_valor)} \n
    Vencimento em ${format(parseISO(boletos.cobranca_data_vencimento),'dd/MM/yyyy')}`,
    value: boletos.boleto_id,
    style: {fontFamily:'Branding-Regular, serif'},
    icon:"pi pi-download",
    command:()=>{downloadBoleto(boletos)},
    }))
    
    function handleSelection(e){
      if(!menu.current){
      }else
      menu.current.toggle(e);
    }
  
    function downloadBoleto(data){
      const binary = Buffer.from(data.boleto_base64.replace(/\s/g, ""),'base64').toString('binary');
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      console.log(binary)
      let view = new Uint8Array(buffer);
  
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }
      const blob = new Blob([view],{type: 'aplication/pdf'})
      const boleto = window.URL.createObjectURL(blob)
      const link = document.createElement("a");
      link.href = boleto;
      link.target = "_blank"
      link.rel = "noopener noreferrer"
      link.download = `boleto-vencimento:${format(
        new Date(data.cobranca_data_vencimento),
        "dd/MM/yyyy"
      )}.pdf`;
      document.body.appendChild(link)
      link.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    }
    
    return(<>
    
        {rowData.length > 0 ? (<>
        <Menu style={{width:'17rem'}} model={listaBoletos} popup ref={menu} />
        <Button 
        className="p-button-rounded boletoButton"
        //style={{width:'2.5rem',height:'2.5rem'}}
        icon="pi pi-download" 
        onClick={(e) => {handleSelection(e)}}
        /></>) : (<> <h5>Feita com cartão</h5>
        </>)}
        
    </>)
}


  